import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleHero from '../components/SimpleHero.tsx';
import SEO, { createWebPageSchema, createOrganizationSchema, createWebSiteSchema } from '../components/SEO.tsx';

const Home: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isKorean = i18n.language === 'ko';

  const structuredData = [
    createOrganizationSchema(),
    createWebSiteSchema(),
    createWebPageSchema({
      title: `${t('companyName')} - ${t('pageTitle.home')}`,
      description: isKorean
        ? '세상 모든 불편함에 솔루션을 제공합니다. 문제 해결 중심의 소프트웨어 개발.'
        : 'Expert software development solutions, innovative projects, and comprehensive JavaScript tutorials.',
      url: '/'
    })
  ];

  return (
    <div className="min-h-screen bg-background-primary">
      <SEO
        title={t('pageTitle.home')}
        description={isKorean
          ? '세상 모든 불편함에 솔루션을 제공합니다. 문제 해결 중심의 소프트웨어 개발.'
          : 'Expert software development solutions, innovative projects, and comprehensive JavaScript tutorials.'}
        keywords={['software development', 'web development', 'react development', 'fullstack developer', 'technical solutions', 'custom software']}
        canonicalUrl="/"
        ogImage="/images/og-home.jpg"
        ogImageAlt={`${t('companyName')} - Professional Software Development`}
        structuredData={structuredData}
      />
      <SimpleHero />
    </div>
  );
};

export default Home;